// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nj-0";